<script>
import { mapActions } from 'vuex';
import PageHeader from 'dashboard/components/dahreply/PageHeader.vue';
import SettingsCard from './components/SettingsCard.vue';
import { apiErrorMessage } from '../../../api/coLiving/errors';

// The ticket defaults card of the settings resource, on its own page behind
// the Tickets page (administrators only).
export default {
  name: 'CoLivingTicketDefaultsPage',
  components: { PageHeader, SettingsCard },
  data() {
    return { loadError: '' };
  },
  async mounted() {
    try {
      await this.fetchSettings();
    } catch (err) {
      this.loadError = apiErrorMessage(
        this,
        err,
        'CO_LIVING.COMMON.LOAD_FAILED'
      );
    }
  },
  methods: {
    ...mapActions('coLivingConfig', ['fetchSettings']),
  },
};
</script>

<template>
  <div
    class="flex-1 overflow-auto p-6"
    data-testid="co-living-ticket-defaults-page"
  >
    <PageHeader
      :title="$t('CO_LIVING.TICKETS.DEFAULTS.TITLE')"
      icon="ticket"
      allow-back
      :back-url="{
        name: 'co_living_tickets',
        params: { accountId: $route.params.accountId },
      }"
    />
    <p
      v-if="loadError"
      class="text-sm text-red-500"
      data-testid="co-living-load-error"
    >
      {{ loadError }}
    </p>
    <SettingsCard v-else card-id="tdef" />
  </div>
</template>
